<style lang="less" scoped>
.boxer {
  position: relative;
}
.viewmode-radio-group {
  position: absolute;
  float: right;
  right: 15px;
  top: 20px;
}
</style>

<template>
  <div class="boxer">
    <div class="sub-title">
      <i class="iconfont icon-entity"></i> 相似度对比
    </div>
      
    <el-radio-group class="viewmode-radio-group" v-model="type">
      <el-radio-button label="grid"><i class="el-icon-menu"></i> 画廊模式</el-radio-button>
      <el-radio-button label="table"><i class="el-icon-s-unfold"></i> 表格模式</el-radio-button>
    </el-radio-group>
    <div class="main-shadow-box">

      <grid-view v-if="type==='grid'"></grid-view>
      <table-view v-else-if="type==='table'"></table-view>
    </div>
  </div>
</template>

<script>
import GridView from "./grid";
import TableView from "./table";
export default {
  components: {
    GridView,
    TableView
  },
  data() {
    return {
      type: "grid"
    };
  }
};
</script>